/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectAdminModel } from './ProjectAdminModel';
import {
    ProjectAdminModelFromJSON,
    ProjectAdminModelFromJSONTyped,
    ProjectAdminModelToJSON,
} from './ProjectAdminModel';

/**
 *
 * @export
 * @interface ListProjectAdminResponse
 */
export interface ListProjectAdminResponse {
    /**
     *
     * @type {number}
     * @memberof ListProjectAdminResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListProjectAdminResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListProjectAdminResponse
     */
    total: number;
    /**
     *
     * @type {Array<ProjectAdminModel>}
     * @memberof ListProjectAdminResponse
     */
    projects: Array<ProjectAdminModel>;
}

/**
 * Check if a given object implements the ListProjectAdminResponse interface.
 */
export function instanceOfListProjectAdminResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('projects' in value)) return false;
    return true;
}

export function ListProjectAdminResponseFromJSON(json: any): ListProjectAdminResponse {
    return ListProjectAdminResponseFromJSONTyped(json, false);
}

export function ListProjectAdminResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListProjectAdminResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        projects: (json['projects'] as Array<any>).map(ProjectAdminModelFromJSON),
    };
}

export function ListProjectAdminResponseToJSON(value?: ListProjectAdminResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        projects: (value['projects'] as Array<any>).map(ProjectAdminModelToJSON),
    };
}
